const contextSwitchStrings = {
  signOutMenuItem: "@:commonStrings.signOut",
  loggedInAs: "Innlogget som",
  buypassAdmin: "Buypass-administrator"
};

export default contextSwitchStrings;